var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "customiser" },
    [
      _c("div", { staticClass: "introduction" }, [
        _c("h1", { staticClass: "heading" }, [
          _vm._v(_vm._s(_vm.rangeTitle) + " radiator "),
          _c("span", { staticClass: "no-print" }, [_vm._v("options")])
        ]),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "button button--primary",
            attrs: { href: _vm.rangeUrl }
          },
          [_vm._v("Back to range")]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c(
          "div",
          { staticClass: "column", attrs: { id: "renderColumn" } },
          [
            !_vm.visualiserOverlay
              ? _c("Render", {
                  attrs: {
                    viewProp: _vm.renderSettings.view,
                    zoomProp: _vm.renderSettings.zoom,
                    backgroundProp: _vm.renderSettings.background,
                    renderCodeProp: _vm.renderCode,
                    finishProp: _vm.custom.finish
                  },
                  on: {
                    renderSettingsChanged: _vm.onRenderSettingsChanged,
                    radiatorRenderError: _vm.onRadiatorRenderError
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.visualiserOverlay
              ? _c("Visualiser", {
                  attrs: {
                    backgroundProp: _vm.custom.finish,
                    overlayProp: _vm.visualiserOverlay
                  }
                })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "column no-print" },
          [
            _c("FinishPicker", {
              attrs: {
                finishGroups: _vm.finishGroups,
                finishSelectedProp: _vm.custom.finish
              },
              on: { finishSelected: _vm.onFinishSelected }
            }),
            _vm._v(" "),
            _c("ValvePicker", {
              attrs: {
                valveGroups: _vm.valveGroups,
                valveSelectedProp: _vm.custom.valve,
                supplementaryHeatersProp: _vm.custom.suppHeaters,
                supplementaryHeaterSelectedProp: _vm.custom.suppHeater
              },
              on: {
                valveSelected: _vm.onValveSelected,
                supplementaryHeaterSelected: _vm.onSupplementaryHeaterSelected
              }
            }),
            _vm._v(" "),
            _c("AccessoryPicker", {
              attrs: {
                if: _vm.accessoryGroup.length,
                accessoryGroupProp: _vm.accessoryGroup
              },
              on: {
                accessorySelected: _vm.onAccessorySelected,
                accessoryRemoved: _vm.onAccessoryRemoved
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "details" },
        [
          _c("Summary", {
            attrs: {
              productProp: _vm.productTitle,
              rangeProp: _vm.rangeTitle,
              finishSelectedProp: _vm.custom.finish,
              valveSelectedProp: _vm.custom.valve,
              supplementaryHeaterProp: _vm.custom.suppHeater,
              accessoriesSelectedProp: _vm.custom.accessories,
              accessoriesQuantitiesProp: _vm.custom.accessoriesQuantities
            },
            on: {
              accessoryRemoved: _vm.onAccessoryRemoved,
              accessoryQtyChanged: _vm.onAccessoryQuantityChange
            }
          }),
          _vm._v(" "),
          _c("CallToActionGroup", {
            attrs: {
              customUrlProp: _vm.url,
              configProp: _vm.urlHash,
              elementIdProp: _vm.elementId,
              finishIdProp: _vm.custom.finish.id,
              valveIdProp: _vm.custom.valve.id,
              suppHeaterProp: _vm.custom.suppHeater ? 1 : 0,
              viewProp: _vm.renderSettings.view,
              zoomProp: _vm.renderSettings.zoom,
              backgroundProp: _vm.renderSettings.background,
              dealerAreaLinkProp: _vm.dealerAreaLink
            }
          }),
          _vm._v(" "),
          _c("TechnicalDetails", {
            attrs: { technicalDetailsProp: _vm.technicalDetails }
          }),
          _vm._v(" "),
          _c("AdditionalInformation", {
            attrs: { additionalInformationProp: _vm.additionalInformation }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("Disclaimer", {
        attrs: {
          isOpenProp: _vm.disclaimer.isOpen,
          copyProp: _vm.disclaimer.copy
        },
        on: { disclaimerClosed: _vm.onDisclaimerClosed }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }